module.exports = __webpack_public_path__ + "static/unltd-ed1e69237d6c09197525d6f1719d2183.svg";